import { render, staticRenderFns } from "./DashboardStatistic.vue?vue&type=template&id=4aad1550&scoped=true&"
import script from "./DashboardStatistic.vue?vue&type=script&lang=js&"
export * from "./DashboardStatistic.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatistic.vue?vue&type=style&index=0&id=4aad1550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad1550",
  null
  
)

export default component.exports